export default __webpack_public_path__ + "static/media/6.ec93dd69.png";